module.exports = __webpack_public_path__ + "img/paytm.031ecc81.png";